export default function base64ToFile(data,call){
  //base64转为图片文件
  var arr = data.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  var file = {};
  file.file = new File([u8arr], '', {type:mime});
  file.content = data;
  call(file);
}



// WEBPACK FOOTER //
// ./src/utils/base64File.js